export default __webpack_public_path__ + "static/media/sonusood.20593fc2.jpg";